import {
  HttpErrorResponse,
  HttpHeaders,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { MAINTENANCE_HEADER, isMaintenanceResponse } from './maintenance.model';
import { MaintenanceService } from './maintenance.service';
import { environment } from '../../environments';

export const maintenanceInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes(environment.shared.apiUrl)) {
    return next(req);
  }

  const maintenanceService = inject(MaintenanceService);

  // Do not hit the backend at all while the maintenance screen is shown.
  if (maintenanceService.active()) {
    return throwError(
      () =>
        new HttpErrorResponse({
          status: 503,
          statusText: 'Service Unavailable',
          url: req.url,
          headers: new HttpHeaders({ [MAINTENANCE_HEADER]: 'true' }),
        })
    );
  }

  return next(req).pipe(
    catchError(error => {
      if (isMaintenanceResponse(error)) {
        maintenanceService.reportBackendMaintenance(error.error?.message);
      } else if (error.status === 503 || error.status === 0) {
        maintenanceService.reportBackendFailure();
      }

      throw error;
    })
  );
};
